// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"4e64d51d3c2349f5","323":"e7d55a9aeea6fe2f","809":"fa09645bb04fe871","981":"97a5d0b9360a1dd9"}[chunkId] + ".js";
};